'use client'

import { HOST } from '@/config'
import { usePathname } from 'next/navigation'

const useUrl = () => {
  const path = usePathname()

  return {
    currentUrl: `${HOST}${path}`,
    host: HOST,
  }
}

export default useUrl
